import React, { useContext, useState } from "react"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { Platform, View } from "react-native"
import { connect } from "react-redux"
import { theme } from "../theme/theme"
import "dayjs/locale/fr"
import HeaderMessenger from "./ChatScreenHeader"
import { DimensionsContext, IS_WEB } from "../utils/mobileUtils"
import { findItemInListWithId } from "@data/utility/dataUtils"
import CommonChat from "@common/messenger/CommonChat"
import { changeCount } from "@data/redux/actions/broadcast"
import { StatusBar } from "@common/systemBars/StatusBar"
import { clearLastPhoto } from "@data/redux/actions/camera"

const ChatScreen = (props) => {
    const { navigation, route } = props
    const tutorId = parseInt(route?.params?.tutorId)
    const studentId = parseInt(route?.params?.studentId)
    // console.log("studentId", studentId)
    // console.log("tutorId", tutorId)

    const studentsFromLives = props.user?.live_sessions?.reduce(
        (acc, session) => {
            return {
                ...acc,
                ...session.students?.reduce((acc2, student) => {
                    return {
                        ...acc2,
                        [student.id]: student,
                    }
                }, {}),
            }
        },
        {},
    )
    const studentsFromTutor = props.user?.students?.reduce((acc, student) => {
        return {
            ...acc,
            [student.id]: student,
        }
    }, {})

    const students = Object.values({
        ...studentsFromLives,
        ...studentsFromTutor,
    })

    const student = studentId
        ? findItemInListWithId(studentId, students)
        : props.user

    // console.log("findItemInListWithId(studentId, props.user?.students)", findItemInListWithId(studentId, props.user?.students))
    const [messages, setMessages] = useState([])

    const liveSessionsThreadIds = props.user?.live_sessions?.reduce(
        (acc, session) => {
            return {
                ...acc,
                ...session.thread_ids,
            }
        },
        {},
    )

    const threadId = studentId
        ? liveSessionsThreadIds[studentId] ?? student?.tutor_messenger_thread_id
        : tutorId
            ? liveSessionsThreadIds?.[tutorId]
            : student?.tutor_messenger_thread_id

    // console.log("threadId", threadId)

    // LogBox.ignoreLogs(["timer"]);

    // useEffect(() => {
    //     loadEarlear;
    // }, []);

    // useEffect(() => {
    //     props.apiRequest(messengerService.getMarkRead, {
    //         threadId: threadId
    //     });
    // }, []);

    const dimensions = useContext(DimensionsContext)

    // const {sendData: triggerTyping} = useLiveKitEventSender()
    // const {sendData: triggerSendMessage} = useLiveKitEventSender()
    //
    // useEffect(() => {
    //     props.apiRequest(messengerService.getMessengerThread, {userId: studentId ?? props.user?.tutor?.id})
    // }, []);

    // useEffect(() => {
    //     let item = props.user?.new_message?.user ? props.user?.new_message : transformMessage(props.user?.new_message);
    //
    //     setMessages((old) => {
    //         if (old.find(msg => msg.threadId === item?.thread_id)) {
    //             return GiftedChat.append(old, [item])
    //         }
    //         return old
    //     });
    // }, [props.user?.new_message]);

    return (
        <>
            <View
                style={{
                    flex: 1,
                    backgroundColor: IS_WEB
                        ? theme.colors.whiteAlmost
                        : theme.colors.greyBg,
                    paddingTop: 0,
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    alignSelf: "center",
                }}
            >
                <HeaderMessenger
                    navigation={navigation}
                    student={student}
                    tutorMessengerThreadId={tutorId ? threadId : null}
                    tutorId={tutorId}
                />
                <CommonChat
                    threadId={threadId}
                    triggerTyping={() => {
                    }}
                    triggerSendMessage={() => {
                    }}
                    messages={messages}
                    setMessages={setMessages}
                    groupChat={false}
                    currentUser={student}
                    tutorId={tutorId}
                    unreadMessagesCount={props.count}
                />
                <StatusBar
                    style="dark"
                    backgroundColor={theme.colors.white}
                    translucent={false}
                />
            </View>
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        count: state.data.currentUser?.object?.unreadInChatMessagesCount,
        token: state.data.session?.object?.token,
    }
}
const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    changeCount,
    clearLastPhoto,
}
export default connect(mapStateToProps, mapDispatchToProps)(ChatScreen)
